import './styles.scss'

import React from 'react'
import PropTypes from 'prop-types'

import I18n from 'lib/i18n'
import { formatNumberWithSpace } from 'lib/utils/format-number-with-space'

const ReviewsBadge = ({ reviews }) => {
  return (
    <div className='reviews'>
      <div className='logo-stars'>
        <img src='/assets/logos/titus.svg' alt='apprentus logo' width={46} height={46}></img>

        <div className='stats'>
          <div className='footer-rate-stars'>
            {Array.from({ length: 5 }, (_, index) => (
              <img key={index} src='/assets/icons/star-18.svg' alt='footer-rate' width={18} height={18} />
            ))}
          </div>

          <div className='details'>
            <p>
              <strong>{reviews.stars}</strong> {I18n.t('pages.reviews.stars')}
            </p>
            <div className='separator'></div>
            <p>
              <strong>{formatNumberWithSpace(reviews.totalReviews)}</strong> {I18n.t('pages.reviews.reviews_count')}
            </p>
          </div>
        </div>
      </div>

      <a className='link' target='_blank' rel='noopener noreferrer' href={reviews.reviewsPageUrl}>
        {I18n.t('layouts.footer.read_reviews')}
      </a>
    </div>
  )
}

ReviewsBadge.propTypes = {
  reviews: PropTypes.object
}

export default ReviewsBadge
